import { useEffect } from 'react';

interface Props {
  GOOGLE_MAP_KEY: string;
  libraries?: Array<string>;
}

export default function useGoogleMapsScript({
  GOOGLE_MAP_KEY,
  libraries = ['drawing', 'geometry', 'places', 'visualization'],
}: Props): void {
  useEffect(() => {
    const script = document.createElement('script');

    const librariesQuery = libraries.join(',');

    // const labelParameters = `&style=element:labels%7Cvisibility:off&style=feature:administrative.country%7Cvisibility:on&style=feature:administrative.country%7Celement:labels%7Cvisibility:on&style=feature:administrative.country%7Celement:labels.text%7Cvisibility:on&style=feature:administrative.land_parcel%7Cvisibility:on&style=feature:administrative.locality%7Cvisibility:on&style=feature:administrative.neighborhood%7Cvisibility:on&style=feature:administrative.province%7Cvisibility:on&style=feature:road%7Cvisibility:on&style=feature:road.arterial%7Cvisibility:on&style=feature:road.highway%7Cvisibility:on&style=feature:road.highway.controlled_access%7Cvisibility:on&style=feature:road.local%7Cvisibility:on&style=feature:water%7Cvisibility:on`;
    const scriptURL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_KEY}&libraries=${librariesQuery}&v=weekly&language=pt-BR&region=BR`;

    script.src = scriptURL;

    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
